import { render } from "./CurrencyRates.vue?vue&type=template&id=06c39624&ts=true"
import script from "./CurrencyRates.vue?vue&type=script&lang=ts"
export * from "./CurrencyRates.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__